/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size, fontWeightRegular } = typography;
const { borderRadius } = borders;
const { tabs } = colors;

const tab = {
  styleOverrides: {
    root: {
       textAlign: "center",
       fontSize: size.md,
       fontWeight: fontWeightRegular,
      textTransform: "none",
       lineHeight: "inherit",
       borderRadius: borderRadius.lg,
       color: `${tabs.color.main} !important`,
       opacity: "1 !important",
       borderRadius: 0,
       background : '#ffffff',
      "& .material-icons, .material-icons-round": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },
      '& .MuiTabs-flexContainer': {
        borderRadius: 0
      },
      '&.MuiButtonBase-root': {
        padding: '12px 16px',
        borderRadius: 0,
        background: '#ffffff'
      },
      "& svg": {
        marginBottom: "0 !important",
        marginRight: pxToRem(6),
      },
      '&.Mui-selected' : {
        borderBottom :"2px solid #ee3134 !important",
        color: "#222222 !important",
      },
      '& .MuiTabs-indicator' : {
        borderRadius :"0px"
      }
    },
    labelIcon: {
      paddingTop: pxToRem(4),
    },
  },
};

export default tab;
